import React, { useState } from "react";
import { DatePicker } from "@smartsuite/react-ui/lib/components/widgets/DatePicker/DatePicker";
import { globalDropdownsZIndex } from "@smartsuite/react-ui/lib/constants/zIndex";
export const DatePillPicker = ({ value, onChange, }) => {
    const [date, setDate] = useState(value);
    return (React.createElement("div", { className: "date-pill-picker" },
        React.createElement(DatePicker, { zIndex: globalDropdownsZIndex, value: value, onChange: setDate, onSelectionDone: () => onChange(date) })));
};
